import type { ExistingSurveyFile } from 'src/redux/slices/Interview/types';

/**
 * Merge the documents the backend just linked onto the asked question into the
 * step's stored file list (ENG-4064).
 *
 * `base` is the authoritative snapshot loaded with the step and wins on
 * collision, so a later re-render (step reload, WS refetch) that already knows
 * about the linked file drops the local copy instead of rendering it twice.
 * Order is stable: snapshot order first, then the newly linked files.
 */
export function mergeSurveyFiles(
  base: ExistingSurveyFile[] | null | undefined,
  extra: ExistingSurveyFile[] | null | undefined
): ExistingSurveyFile[] {
  const seen = new Set<number>();
  const merged: ExistingSurveyFile[] = [];
  for (const file of [...(base ?? []), ...(extra ?? [])]) {
    if (!file || typeof file.file_id !== 'number') {
      continue;
    }
    if (seen.has(file.file_id)) {
      continue;
    }
    seen.add(file.file_id);
    merged.push(file);
  }
  return merged;
}
